/* ============================================================
   CAPILLA DEL ROSARIO - scroll reveal
   Adds .is-visible to [data-animate] elements when they enter
   the viewport. Includes a fallback: if IntersectionObserver is
   unavailable or anything fails, all elements are revealed so
   content is NEVER left hidden.
   ============================================================ */
(function () {
  'use strict';

  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.add('is-visible');
    }
  }

  function init() {
    var nodes = document.querySelectorAll('[data-animate]');
    if (!nodes.length) return;

    // Fallback: no observer support -> show everything immediately.
    if (!('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    try {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
      );

      nodes.forEach(function (node) {
        observer.observe(node);
      });

      // Safety net: reveal anything still hidden after 3s.
      window.setTimeout(function () {
        revealAll(document.querySelectorAll('[data-animate]:not(.is-visible)'));
      }, 3000);
    } catch (e) {
      revealAll(nodes);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
